import React from 'react';
import { Link } from 'react-router-dom';

export default function NewsletterForm({ btnText, btnArrowUrl }) {
  return (
    <>
      <Link to={'https://noohrawrites.substack.com/?utm_campaign=email-home&r=4xjwrw'} className="">
        <button className="cs_btn cs_style_1">
          <span>{btnText}</span>
          <i>
            <img src={btnArrowUrl} alt="Icon" />
            <img src={btnArrowUrl} alt="Icon" />
          </i>
        </button>
      </Link>
    </>
  );
}
